import script from "./FancySelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FancySelect.vue?vue&type=script&setup=true&lang=js"

import "./FancySelect.vue?vue&type=style&index=0&id=22d1e649&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d1e649"]])

export default __exports__